import { ActionsTypes, SET_CLAIM, RESET_CLAIM } from "./claim-actions";
import { ClaimState, initialState } from "./claim-state";

export default (state: ClaimState = initialState, action: ActionsTypes): ClaimState => {
    switch (action.type) {
        case SET_CLAIM: {
            return {
                ...state,
                ...action.payload
            };
        }
        case RESET_CLAIM: {
            return initialState;
        }
        default:
            return state;
    }
};
